// extracted by mini-css-extract-plugin
export default {"root":"CompanySettings_root__KB6Be","logo":"CompanySettings_logo__ukiQ8","base":"CompanySettings_base__yBD-8"};